import { plural } from './plural';

/**
 * Подпись «напомню за сутки и за N часов» из настроек организации. Раньше
 * строка была зашита и врала: писала «за час», а бот слал за два. Пустая
 * строка — напоминания выключены, строку на экране не рисуем.
 */
export function reminderCopy(r: { dayBefore: boolean; hoursBefore: number } | undefined, verb = 'Напомню'): string {
  if (!r) return '';
  const parts: string[] = [];
  if (r.dayBefore) parts.push('за сутки');
  if (r.hoursBefore > 0) parts.push(`за ${r.hoursBefore} ${plural(r.hoursBefore, 'час', 'часа', 'часов')}`);
  return parts.length ? `${verb} ${parts.join(' и ')}` : '';
}
